import React, { Component, PropTypes } from 'react';
import update from 'react/lib/update';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import SentenceRow from './sentence_row';
import {GetForingLang, GetInterfaceLang, GetSentenceStat, GetOneLearningLanguage, delSentense, getDetailSentense, GetAllLanguage, getSentence, changePosition, PaginationSentence, getSentenceFilter} from '../../actions/index';
import PaginationComponent from '../pagination';
import Filter from '../filterSentence';
import _ from 'lodash';
@DragDropContext(HTML5Backend)
class Sentence extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.addSentence = this.addSentence.bind(this);
        this.renderTooltip = this.renderTooltip.bind(this);
        this.renderSentense = this.renderSentense.bind(this);
        this.editSentence = this.editSentence.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.delWord = this.delWord.bind(this);
        this.delWordOpenModal = this.delWordOpenModal.bind(this);
        this.renderIcon = this.renderIcon.bind(this);
        this.filterInput = this.filterInput.bind(this);

        this.moveCard = this.moveCard.bind(this);
        this.dropCard = this.dropCard.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);

        this.state = {
            cards: [],
            anotherCard: {}
        }
    }
    moveCard(dragIndex, hoverIndex) {
        const { cards } = this.state;
        const dragCard = cards[dragIndex];
        const hoverCard = cards[hoverIndex];
        this.setState({anotherCard : hoverCard});
        const dragPosition = dragCard.position;
        const hoverPosition = hoverCard.position;
        dragCard.position = hoverPosition;
        hoverCard.position = dragPosition;
        this.setState(update(this.state, {
            cards: {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, dragCard]
                ]
            }
        }));
    }
    dropCard(droppedIndex) {
        const { cards } = this.state;
        const droppedCard = cards[droppedIndex];
        let token = localStorage.getItem('id_token_admin');
        // TODO call an action to save this position
        this.props.changePosition(token, droppedCard.id, droppedCard.position)
        // this.props.changePosition(token, this.state.anotherCard.id, this.state.anotherCard.position)
    }

    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetForingLang(token);
        this.props.GetInterfaceLang(token);
        this.props.GetAllLanguage(token);
        this.props.GetSentenceStat(this.props.params.id);
        this.props.GetOneLearningLanguage(this.props.params.id, token);
        this.props.getSentence(token, this.props.params.id).then((response)=>{
            this.setState({cards: response.payload.data.results});
        });
    }
    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
        $('.selectpicker').selectpicker();

    }
    componentWillUnmount(){
        this.props.lang.sentense = {}
    }
    addSentence(id_before){
        if(typeof id_before == 'number'){
            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence/add/'+id_before);
        }else{
            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence/add');
        }
    }
    editSentence(id, item){
        this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence/edit/'+id+'/');
    }
    delWord(){
        let token = localStorage.getItem('id_token_admin');
        this.props.delSentense(token, this.props.lang.sentense_detail.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                $('input[name="phrase"]').val('')
                this.props.GetSentenceStat(this.props.params.id);
                this.props.getSentence(token, this.props.params.id).then((response)=>{
                    this.setState({cards: response.payload.data.results});
                });
            }
        });
    }
    delWordOpenModal(id, flang, item){
        this.props.lang.sentense_detail = {};
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelWord').modal('show');
        $('#DelWord').on('shown.bs.modal', function () {
            that.props.getDetailSentense(id, token, flang);
        });
    }
    closeModal(){
        $('#DelWord').modal('hide');
        this.props.lang.sentense_detail = {};
    }
    handlePageChange(data){
        let token = localStorage.getItem('id_token_admin');
        this.setState({activePage: data});
        this.props.PaginationSentence(token, data, this.props.params.id).then((response)=>{
            this.setState({cards: response.payload.data.results});
        });
    };
    labelFunction(live_situation_type, notification, sentence_number_notification){
        let text = '';
        if(live_situation_type != null &&  live_situation_type == 1){
            text += 'LW ';
        }else if (live_situation_type != null &&  live_situation_type == 2){
            text += 'LS '
        }
        if(notification != null){
            text += 'SP '
        }
        if(sentence_number_notification != null){
            text += 'NP '
        }
        return text;
    };
    renderIcon(item){
        return item.map((code)=>{
            if(code.word_translations != '<p><br></p>' && code.word_translations != '') {
                return this.props.lang.interface_lang.results.map((lang) => {
                    if(lang.id == code.blang){
                        return <i>{lang.lang.code}</i>
                    }
                });
            }
        });
    }
    renderSentense(){
        let newArr = this.state.cards.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
        });
        return newArr.map((item, i)=> {
            return (
                <SentenceRow
                    key={item.id}
                    index={i}
                    id={item.id}
                    moveCard={this.moveCard}
                    dropCard={this.dropCard}
                    editSentence={this.editSentence}
                    delWordOpenModal={this.delWordOpenModal}
                    position={item.position}
                    phrase={item.phrase}
                    live_situation_type={item.live_situation_type}
                    sentence_number_notification={item.sentence_number_notification}
                    notification={item.notification}
                    study_type={item.study_type}
                    flang={item.flang}
                    translations={item.translations}
                    addSentence={this.addSentence}
                    renderIcon={this.renderIcon}
                    labelFunction={this.labelFunction}
                />
            )
        })
    }
    renderTooltip(){
        return this.props.lang.interface_lang.results.map((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                return this.props.lang.sentence_stat.map((stat)=>{
                    if(item.id == stat.blang){
                        let string = stat.translated+ ' / ' +stat.total
                        return(
                            <p key={item.id} className="pull-left info-item" data-toggle="tooltip" data-placement="top" title={string} >{item.lang.name}</p>
                        )
                    }

                })
            }
        })
    }
    filterInput(e){
        if(e.target && e.target.name == 'woblang'){
            $('select[name="wblang"]').val('selectDefault')
        }
        if(e.target && e.target.name == 'wblang'){
            $('select[name="woblang"]').val('selectDefault')
        }
        let token = localStorage.getItem('id_token_admin');
        let data = {
            flang: $('input[name="flangs"]').val(),
            phrase: $('input[name="phrase"]').val(),
            study_type: $('select[name="study_type"]').val() != 'selectDefault' ? $('select[name="study_type"]').val() : '',
            woblang: $('select[name="woblang"]').val() != 'selectDefault' ? $('select[name="woblang"]').val() : '',
            wblang: $('select[name="wblang"]').val() != 'selectDefault' ? $('select[name="wblang"]').val() : ''
        }

        this.props.getSentenceFilter(token, data).then((response)=>{
            this.setState({cards: response.payload.data.results});
        });
        $('.selectpicker').selectpicker('refresh')
        // $('#searchSentence').submit()
    }
    render() {
        return (
            <div>
                <div className="dashboard-wrapper">
                    <div className="dashboard-title clearfix">
                        <div className="pull-left">
                            <p className="dashboard-title">Sentence list</p>
                            <p className="dashboard-text">{this.props.lang.learning_lang_one.lang && this.props.lang.sentence_stat ? this.props.lang.learning_lang_one.lang.name : "" }</p>
                        </div>
                        <button onClick={this.addSentence} type="button" className="pull-right btn btn-primary">
                            <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                            Add sentence
                        </button>
                    </div>
                    <div>
                        <div className="col-md-12">
                            <div className="white-block ">
                                <div className="clearfix static-header-buttons">
                                    <p className="pull-left">Translate to</p>
                                    <div className="block-info-group">
                                        {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.interface_lang.results ? this.renderTooltip() : ""}
                                    </div>
                                </div>
                                <div className="separate-horizontal"> </div>
                                {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.interface_lang.results ?
                                    <Filter id={this.props.params.id} filterInput={this.filterInput}/>
                                    :
                                    ""
                                }
                            </div>
                        </div>
                        {this.state.cards && this.state.cards.length > 0 && this.props.lang.interface_lang.results ?
                            <div>
                                <div className="col-md-12">
                                    <div className="common-list four clearfix plFirst draggable">
                                        <p>#</p>
                                        <p>Sentence</p>
                                        <p>Function</p>
                                        <p className="pull-right">Option</p>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    { this.renderSentense() }
                                </div>
                                {this.props.lang.sentense ?
                                    <PaginationComponent
                                        data={this.props.lang.sentense}
                                        activePage={this.state.activePage}
                                        handlePageChange = {this.handlePageChange}
                                    />
                                    :""
                                }
                            </div>
                            :
                            <div className={this.state.cards && this.state.cards.length < 0 && this.props.lang.interface_lang.results || $.isEmptyObject(this.props.lang.interface_lang) ? "for_preloader" : 'for_preloader dn'}>
                                <div className="preloader-wrapper big active">
                                    <div className="spinner-layer spinner-blue-only">
                                        <div className="circle-clipper left">
                                            <div className="circle" />
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle" />
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.props.lang.sentense.results && this.props.lang.sentense.results === 0 && this.props.lang.interface_lang.results && <p className="noResults">No items result</p>}
                    </div>

                    <div className="modal fade" id="DelWord" tabIndex="-1" role="dialog" aria-labelledby="DelWordLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelWord"></span>
                                    <p>Do you really want to delete sentence {this.props.lang.sentense_detail ? <span>"{this.props.lang.sentense_detail.phrase}"</span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delWord} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>

                </div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}

export default connect(mapStateToProps, {GetForingLang, GetInterfaceLang, GetSentenceStat, GetOneLearningLanguage, delSentense, getDetailSentense, GetAllLanguage, getSentence, changePosition, PaginationSentence, getSentenceFilter})(Sentence);


// WEBPACK FOOTER //
// ./src/components/language/sentence.js